export const KYC_APPROVED_ANIMATION = {
  LOTTIE_INITIAL_Y: -44,
  LOTTIE_DURATION: 0.5,
  TITLE_DELAY: 0.18,
  TITLE_DURATION: 0.28,
  ITEM_BADGE_BASE_DELAY: 0.34,
  ITEM_BADGE_STAGGER_DELAY: 0.12,
  ITEM_BADGE_DURATION: 0.22,
  ITEM_TEXT_DELAY_OFFSET: 0.08,
  ITEM_TEXT_INITIAL_X: -16,
  ITEM_TEXT_DURATION: 0.24,
  BUTTON_REVEAL_TARGET_MS: 500,
  BUTTON_REVEAL_DELAY_MS: 300,
  CTA_FADE_UP_INITIAL_Y: 20,
  CTA_FADE_UP_DURATION: 0.28,
  CTA_PROGRESS_DURATION_MS: 3000,
} as const;

export const KYC_APPROVED_LOGIC = {
  STEP_LAST_INDEX_OFFSET: 1,
  MIN_STEP_INDEX: 0,
  MILLISECONDS_PER_SECOND: 1000,
} as const;

export const KYC_APPROVED_STEP_ICON = {
  BADGE_SIZE: 30,
  ICON_SIZE: 20,
  CONNECTOR_HEIGHT: 28,
  CONNECTOR_WIDTH: 6,
} as const;

export const KYC_APPROVED_STEP_ITEMS = [
  {
    id: 'create-parent-account',
    number: 1,
    translationKey: 'kyc.approved.steps.step_1',
    isCompleted: true,
    showConnector: true,
  },
  {
    id: 'add-your-kid',
    number: 2,
    translationKey: 'kyc.approved.steps.step_2',
    isCompleted: false,
    showConnector: true,
  },
  {
    id: 'select-mocard',
    number: 3,
    translationKey: 'kyc.approved.steps.step_3',
    isCompleted: false,
    showConnector: false,
  },
] as const;

export const KYC_APPROVED_CO_PARENT_STEP_ITEMS = [
  {
    id: 'create-parent-account',
    number: 1,
    translationKey: 'kyc.approved.steps.step_1',
    isCompleted: true,
    showConnector: true,
  },
  {
    id: 'log-in-to-modak-app',
    number: 2,
    translationKey: 'kyc.approved.steps.co_parent_step_2',
    isCompleted: false,
    showConnector: false,
  },
] as const;
